import React, { Component } from 'react'
import { FormattedMessage } from "react-intl";
import $ from "jquery";
const uuidv4 = require('uuid/v4')

class ConfirmButton extends Component {

    constructor(props, context) {
        super(props, context)

        const identifier = this.props.identifier || ''
        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'confirm-' + uuidv4(),
            type: this.props.type || '',
            onClick: this.props.onClick || function () { },
            onModalRender: this.props.onModalRender || null,
            disabled: this.props.disabled === true,
            identifier: identifier,
            show: false,
            isLink: this.props.isLink || false,
            ignoreConfirm: this.props.ignoreConfirm || false,
            style: this.props.style || {},
        }
        this.handleClick = this.handleClick.bind(this)
        this.yes = this.yes.bind(this)
        this.no = this.no.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const identifier = nextProps.identifier || ''
        this.setState({
            className: nextProps.className || '',
            type: nextProps.type || '',
            identifier: identifier,
            disabled: nextProps.disabled === true,
            onClick: nextProps.onClick || function () { },
            ignoreConfirm: nextProps.ignoreConfirm || false,
        })
    }

    onModalRender(callback) {
        if (this.state.onModalRender) {
            this.state.onModalRender(this.getModal(), callback)
        } else {
            callback()
        }
    }

    handleClick(event) {
        event.preventDefault()
        if (!this.state.ignoreConfirm) {
            this.setState({
                show: true
            }, () => {
                this.onModalRender(() => {
                    $('#' + this.state.modalId).modal('show')
                })
            })
        } else {
            this.state.onClick(event)
        }
    }

    yes(event) {
        event.preventDefault()
        this.setState({
            show: false
        }, () => {
            this.onModalRender(() => {
                $('#' + this.state.modalId).modal('hide')
            })
            $('#' + this.state.modalId).modal('hide')
            this.state.onClick(event)
        })
    }

    no(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        this.setState({
            show: false
        }, () => {
            this.onModalRender(() => {
                $('#' + this.state.modalId).modal('hide')
            })
        })
    }

    renderModal() {
        return <div className="modal"
            id={this.state.modalId}
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div className="modal-dialog modal-dialog-centered" role="document" >
                <div className="modal-content" style={{ zIndex: 1200 }}>
                    <div className="modal-body">
                        <p className={"p-2 text-left"}>
                            {this.props.message ? this.props.message : <FormattedMessage
                                id="common.confirm.modal.delete_are_you_sure_message"
                                defaultMessage="Are you sure you want to delete {identifier} ?"
                                values={{
                                    identifier: this.state.identifier
                                }}
                            />}
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={this.no}>
                            <FormattedMessage
                                id="common.confirm.modal.no_btn"
                                defaultMessage="No"
                            />
                        </button>
                        <button type="button" className="btn btn-primary" onClick={this.yes}>
                            <FormattedMessage
                                id="common.confirm.modal.yes_btn"
                                defaultMessage="Yes"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }

    getModal() {
        return <div className={!this.state.show ? 'd-none' : ''} key={2}>{this.renderModal()}</div>
    }

    render() {
        const items = []
        if (!this.state.onModalRender) {
            items.push(this.getModal())
        }
        if (this.state.isLink) {
            items.push(<a href={'#'} key={1} className={this.state.className} onClick={this.handleClick} disabled={this.state.disabled} type={this.state.type}>
                {this.props.children}
            </a>)
        } else {
            items.push(<button key={1} className={this.state.className} onClick={this.handleClick} disabled={this.state.disabled} type={this.state.type} style={this.state.style}>
                {this.props.children}
            </button>)
        }
        return items
    }
}

export default ConfirmButton


// WEBPACK FOOTER //
// ./src/common/button/confirmbutton.component.jsx